import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  async function handleLogin(e) {
    e.preventDefault();

    setError("");

    if (!email || !password) {
      setError("Ingresa correo y contraseña.");
      return;
    }

    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError("Correo o contraseña incorrectos.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="login-page">
      <section className="login-card">
        <div className="login-header">
          <div className="login-logo-container">
            <img
              src="/images/IsologoWiblocolor1.png"
              alt="Logo de Wiblo"
              className="login-logo"
            />
          </div>

          <h1 className="login-title">Panel administrativo</h1>
          <p className="login-subtitle">
            Ingresa tus credenciales para continuar
          </p>
        </div>

        <form className="login-form" onSubmit={handleLogin} noValidate>
          <label className="login-field">
            <span className="login-label">Correo</span>

            <div className="login-input-group">
              <span className="material-symbols-rounded login-input-icon">
                👤
              </span>

              <input
                className="login-input"
                type="email"
                placeholder="correo@ejemplo.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
              />
            </div>
          </label>

          <label className="login-field">
            <span className="login-label">Contraseña</span>

            <div className="login-input-group">
              <span className="material-symbols-rounded login-input-icon">
                🔐
              </span>

              <input
                className="login-input"
                type="password"
                placeholder="Tu contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </div>
          </label>

          {error && (
            <p className="login-error">
              <span className="material-symbols-rounded login-error-icon">
                ❗
              </span>
              {error}
            </p>
          )}

          <button className="login-button" type="submit" disabled={loading}>
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>
      </section>
    </main>
  );
}

export default Login;